import React, { useEffect, useState } from "react"
import { navigate, Link } from "gatsby"
import WideHero from "./_WideHero"
import Content from "./_Content"
import axios from "axios"
import { useLocation } from "@reach/router"
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";

// PROD
const baseURL = "https://ekprmilgjh.execute-api.us-east-1.amazonaws.com/Prod/search?"
// DEV
// const baseURL = "https://6hrrdoabd5.execute-api.us-east-1.amazonaws.com/Prod/search?"

export default function CareerDetails() {
  const browserLocation = useLocation()
  const [jobDetails, setJobDetails] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(async () => {
    const id = browserLocation.search.split("?id=")[1]
    if (!id) {
      if (typeof window !== "undefined") {
        navigate("/careers")
      }
    } else {
      await fetchJobDetails(id)
    }
  }, [])

  // TODO: Refactor this
  const showErrorMessage = () => {
    return (
      <div className="default-grid">
        <div className="px-10 py-8 col-span-full">
          <div className="space-y-8">
            <div className="flex justify-center gap-6 mb-16">
              <div className="flex justify-center">
                <div className="flex flex-col justify-center">
                  <div className="text-center text-2xl font-bold">
                    <p className="md:text-2xl text-red lead-bold">
                      This job does not exist or is no longer available.
                    </p>
                  </div>
                  <div className="text-center text-2xl font-bold">
                    <Link
                      className="nav-primary text-mineralGray focus:text-violet focus:outline-none hover:opacity-75"
                      href="/careers"
                    >
                      Click here to browse more jobs.
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const fetchJobDetails = async id => {
    setIsLoading(true)
    try {
      const response = await axios.get(`${baseURL}id=${id}`)
      if (response.status === 200) {
        setJobDetails(response.data.listing)
      }
    } catch (err) {
       
    }
    setIsLoading(false)
  }

  if (isLoading) {
    return (
      <div>
        <ReactPlaceholder
          ready={!isLoading}
          type="rect"
          style={{ width: "100%", height: 350 }}
          showLoadingAnimation
        ></ReactPlaceholder>
        <div className="jdWrapper">
          <ReactPlaceholder
            ready={!isLoading}
            type="rect"
            style={{ width: "100%", height: 1000 }}
            showLoadingAnimation
            className="mt-5"
          ></ReactPlaceholder>
        </div>
      </div>
    )
  }
  if (jobDetails && Object.keys(jobDetails).length > 0) {
    return (
      <section data-slice="CareerBoard" className="space-y-6 pb-24">
        <WideHero jobTitle={jobDetails.Title} />
        <Content jobDetails={jobDetails} />
      </section>
    )
  }
  return showErrorMessage()
}
